<template>
<!--    生成随货单-->
    <div>
        <div class="h-piece">
            <div class="h-formBox">
                <el-form :inline="true" :model="q" class="demo-form-inline h-formBorder" label-width="140px">
                    <div class="h-thirdColumn w-newColumn">
                        <el-form-item label="开始交货日期">
                        <el-date-picker
                            style="width: 100%;"
                            v-model="q.expectStartDate"
                            type="date"
                            value-format="yyyy-MM-dd"
                            placeholder="开始日期"
                        ></el-date-picker>
                        </el-form-item>
                        <el-form-item label="结束交货日期">
                        <el-date-picker
                            style="width: 100%;"
                            v-model="q.expectEndDate"
                            type="date"
                            value-format="yyyy-MM-dd"
                            placeholder="结束日期"
                        ></el-date-picker>
                        </el-form-item>

                        <el-form-item label="sap采购订单号">
                        <el-input v-model="q.poOrderNo" placeholder></el-input>
                        </el-form-item>
                        <el-form-item label="物料编码">
                        <el-input v-model="q.productNo" placeholder></el-input>
                        </el-form-item>
                    </div>
                    <el-collapse-transition>
                        <div v-show="isScreen">
                            <div class="h-thirdColumn w-newColumn">
                                <el-form-item label="订单开始日期">
                                <el-date-picker
                                    style="width: 100%;"
                                    v-model="q.waybillStartDate"
                                    type="date"
                                    value-format="yyyy-MM-dd"
                                    placeholder="开始日期"
                                ></el-date-picker>
                                </el-form-item>
                                <el-form-item label="订单结束日期">
                                <el-date-picker
                                    style="width: 100%;"
                                    v-model="q.waybillEndDate"
                                    type="date"
                                    value-format="yyyy-MM-dd"
                                    placeholder="结束日期"
                                ></el-date-picker>
                                </el-form-item>
                                <el-form-item label="仅显示可打印记录">
                                    <el-switch
                                        v-model="isPrint"
                                        active-color="#13ce66"
                                        inactive-color="#ff4949">
                                    </el-switch>
                                </el-form-item>
                            </div>
                        </div>
                    </el-collapse-transition>
                </el-form>
                <div class="l-screenBox">
                <div class="l-screen" @click="collapseChange">
                    <img :src="isScreen?closeScreen:drawScreen" alt />
                    <div class="l-screenText">{{isScreen?"收起":"展开"}}</div>
                </div>
                <div class="l-retrieval">
                    <el-button class="h-btn h-formBtn" @click="query">检索</el-button>
                    <el-button class="h-btn h-formBtn h-bgwhite" @click="resetData">重置</el-button>
                </div>
                </div>
            </div>
        </div>
        <div>
            <el-table
                :data="tableData2"
                @selection-change="handleSelectionChange"
                max-height="500"
                style="width: 100%" >
                <el-table-column type="selection" width="45" :label="all"></el-table-column>
                <el-table-column fixed type="index" label="#" min-width="40"></el-table-column>

                <el-table-column prop="productNo" label="物料编码" min-width="130" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column
                prop="productDes"
                label="物料描述"
                min-width="140"
                :show-overflow-tooltip="true"
                ></el-table-column>
                <el-table-column prop="expectDate" label="交货日期" min-width="110" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column prop="waybillDate" label="订单日期" min-width="110" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column prop="unit" label="基本单位" min-width="100"  :show-overflow-tooltip="true"></el-table-column>

                <el-table-column prop="count" label="需求数量" min-width="100" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column prop="printCount" label="已打印数量" min-width="100" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column prop="deliveryCount" label="送货数量" min-width="100" >
                    <template slot-scope="scope">
<!--                        <el-button size="small" class="el-button-new" @click="add(scope.row)">+</el-button>-->
                        <el-input
                            :min="1"
                            :value="1"
                            oninput="value=value.replace(/[^\d.]/g,'')"
                            size="small"
                            class="inner-number"
                            style="width: 100%;text-align: center;"
                            v-model="scope.row.deliveryCount"
                        ></el-input>
<!--                        <el-button size="small" class="el-button-new" @click="reduce(scope.row)">-</el-button>-->
                    </template>
                </el-table-column>
                <el-table-column prop="poOrderNo" label="sap采购订单号" width="140" :show-overflow-tooltip="true"></el-table-column>

                <el-table-column prop="cgCode" label="采购订单号" width="140" :show-overflow-tooltip="true"></el-table-column>

                <el-table-column
                prop="poOrderLineNo"
                label="采购订单行项目号"
                width="160"
                :show-overflow-tooltip="true"
                ></el-table-column>

                <el-table-column
                        prop="ycid"
                        label="预测单号"
                        width="160"
                        :show-overflow-tooltip="true"
                ></el-table-column>
                <el-table-column
                        prop="factory"
                        label="工厂"
                        width="140"
                        :show-overflow-tooltip="true"
                >
                </el-table-column>
                <!-- <el-table-column
                                label="操作"
                                fixed="right"
                                width="180"
                        >
                            <template slot-scope="scope">
                                <div style="text-align: left;">
                                    <el-button
                                            type="text"
                                            size="small"
                                            class="h-tableLink h-btn" @click="todetail(scope.row)">
                                        重新提交
                                    </el-button>
                                </div>
                            </template>
                </el-table-column>-->
            </el-table>
            <div class="h-tableB h-mrt30">
                <div class="h-tableBL">
                    <el-button class="h-btn h-formBtn h-bgblueQ" :disabled="this.multipleSelection.length==0" style="margin-left:20px;" @click="printList">生成随货单</el-button>
                </div>

                <div class="h-pagination2">
                    <el-pagination
                            background
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page.sync="pageNo"
                            :page-sizes="[10,50,100,500]"
                            :page-size="q.pageSize"
                            layout="total, sizes, prev, pager, next, jumper"
                            :total="q.total"
                    ></el-pagination>
                </div>
            </div>
        </div>
      <el-dialog :close-on-click-modal="false" :visible.sync="centerDialogVisible" class="h-dialog2">
        <div class="h-dialogImg">
          <div class="h-disTable">
            <div class="h-tableCell">
              <h1>医疗器械产品信息维护</h1>
            </div>
          </div>
        </div>
        <div class="h-formLine h-mrb-38" style="margin: 0.38rem 0 0 0;">
          <el-form :inline="true" :model="medicalDeviceData" class="demo-form-inline h-formBorder"
                   style="margin-top: 0.4rem">
            <el-form-item label="产品批号" class="h-elformWrap-2" style="margin-left:0.5rem;">
              <el-input  v-model="medicalDeviceData.batchNumber" :clearable="true" placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item label="生产日期" class="h-elformWrap-2" style="margin-left:0.5rem;">
              <el-date-picker type="date" placeholder="选择时间" value-format="yyyy-MM-dd" v-model="medicalDeviceData.productionDate"
              ></el-date-picker>
            </el-form-item>
          </el-form>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="centerDialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="printListMd">确 定</el-button>
        </div>
      </el-dialog>
    </div>
</template>
<script>
import ss from '../../../api/SystemService'
export default {
    data() {
        return {
        isPrint:true,
        // 展开折叠筛选
        isScreen: false,
        closeScreen: require("@/assets/images/pimg/closeallic.png"),
        drawScreen: require("@/assets/images/pimg/dobleArr.png"),
        all: "全部",
        multipleSelection: [],
        centerDialogVisible:false,
        pageNo:1,
        medicalDeviceData:{
          batchNumber:null,
          productionDate:null,
        },
        tableData2: [],
        q: {
            pageSize: 10,
            pageNo: 1,
            total: 0,
            // orderCode: "",
            // endDate: "",
            // startDate: ""
            waybillStartDate:'',
            waybillEndDate:'',
            poOrderNo:'',
            poNumber:'',
            expectStartDate:'',
            isPrint:true,
            expectEndDate:'',
        },
        codeList: [
            { value: 10, label: "暂存" },
            { value: 20, label: "审批中" },
            { value: 30, label: "已驳回" },
            { value: 40, label: "审核通过" }
        ],
        chanpinzhuangtai: [
            {
            value: 1,
            label: "虚拟物料"
            },
            {
            value: 0,
            label: "真实物料"
            }
        ]
        };
    },
    mounted(){
        this.query()
    },
    methods: {
        query() {
            //查询
            this.$set(this.q,'isPrint',this.isPrint?'1':'0')
            ss.chanpin.selectPageInfo(this.q).then(res => {
               for(let item of res.records){
                   let str = parseFloat(item.count) - parseFloat(item.printCount);
                   item.deliveryCount = str > 0 ? str : 0 ;
               }
                    this.tableData2 = res.records,
                    this.q.total = res.total;
            })
        },
        resetData() {
            this.q = {
                materialCode: null,
                checkStatus: null,
                startDate: null,
                endDate: null,
                levelCode: null,
                pageSize: 10,
                pageNo: 1,
                total: 0,
                isPrint:'1',
            };
            this.isPrint = true;
            this.query()
        },
        printList(){
            var statusPrint = ''
            var data = this.multipleSelection
            for (var i = 0; i < this.multipleSelection.length; i++) {
                if (this.multipleSelection[i].count - Number(this.multipleSelection[i].deliveryCount) <0 ) {
                    this.$msg.msge("请输入正确的数量！");
                    return false;
                }else{
                    statusPrint = '1'
                }
                //proli.push(this.multipleSelection[i].materialCode);
            }
            var isMedicalDevice = false
            for (var i = 0; i < this.multipleSelection.length; i++) {
              //判断有没有医疗器械
              if( this.multipleSelection[i].isMedicalDevice == '是'){
                isMedicalDevice = true;
                break;
              }
            }
            if(isMedicalDevice){
              var product = this.multipleSelection[0].productNo;
              for (var i = 0; i < this.multipleSelection.length; i++) {
                //判断有没有医疗器械
                if( this.multipleSelection[i].productNo != product){
                  this.$msg.msge("医疗器械产品,需录入批号和生产日期,只能提交同一产品！");
                  return false;
                }
              }
              this.medicalDeviceData.batchNumber = null;
              this.medicalDeviceData.productionDate = null;
              this.centerDialogVisible = true;
              return false;
            }
            if(statusPrint == '1'){
                ss.chanpin.createDeliveryInstruction(data).then(res =>{
                    if(res.f == true){
                        this.$message({
                            message: res.msg,
                            type: 'success'
                        });
                        this.query()
                    }else{
                        this.$message.error(res.msg);
                    }
                })
            }
        },
        printListMd(){
          var statusPrint = ''
          var data = this.multipleSelection
          for (var i = 0; i < this.multipleSelection.length; i++) {
            if (this.multipleSelection[i].count - Number(this.multipleSelection[i].deliveryCount) <0 ) {
              this.$msg.msge("请输入正确的数量！");
              return false;
            }else{
              statusPrint = '1'
            }
            this.multipleSelection[i].batchNumber = this.medicalDeviceData.batchNumber;
            this.multipleSelection[i].productionDate = this.medicalDeviceData.productionDate;
          }
          if(statusPrint == '1'){
            ss.chanpin.createDeliveryInstruction(data).then(res =>{
              if(res.f == true){
                this.$message({
                  message: res.msg,
                  type: 'success'
                });
                this.centerDialogVisible = false;
                this.query();
              }else{
                this.$message.error(res.msg);
              }
            })
          }
        },
        // 展开折叠
        collapseChange() {
        this.isScreen = !this.isScreen;
        },
        getSing() {
        },
        reduce(row) {},
        add(row) {
            row.languageCode = Number(row.languageCode) + 1;
        },
        // 获取所有选取的信息
        handleSelectionChange(val) {
            this.multipleSelection = val;
            this.ids = this.multipleSelection.map(item => item.id).join(); //获取所有选中行的id组成的字符串，以逗号分隔
            this.businessId = this.multipleSelection
                .map(item => item.businessId)
                .join();
        },
         // 分页
        handleCurrentChange: function (pageNo) {
            this.q.pageNo = pageNo; //点击第几页
            this.query()
        },

        // 每页信息数量更改
        handleSizeChange(val) {
            this.pageNo = 1
            this.q.pageSize = val
            this.query()
        },
    }
};
</script>
<style scoped>
    .inner-number {
    width: 50px;
    margin: 0 5px;
    }
    .inner-number /deep/ .el-input__inner {
    height: 24px;
    line-height: 24px;
    }
    .el-button-new {
    height: 24px;
    line-height: 24px;
    padding: 0 10px;
    margin: 0;
    visibility: middle;
    vertical-align: middle;
    margin-top: -16px;
    background: #1b78e6;
    color: #fff;
    }
</style>
